import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute z-50 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
}
const _hoisted_2 = {
  key: 1,
  class: "absolute top-0 left-0 w-full h-full z-[1101]"
}

import { Spin } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'SpinnerLoading',
  props: {
    loading: { type: Boolean },
    tip: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(props.loading ? 'brightness-75 rounded-full ease-linear duration-200' : '')
  }, [
    (props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(Spin), {
            tip: props.tip,
            size: "large"
          }, null, 8, ["tip"])
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}
}

})